var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"padding-bottom":"20vh","padding-top":"100px"}},[_c('h1',[_vm._v("Edit Blog Post")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('app-blog-post-form')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5834d9ab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/EditBlogPost.vue
// module id = 783
// module chunks = 0